import React from 'react';
import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkSpacingSpacesBreaks } from 'uitk-react-spacing/dist/types';
import { UitkText } from 'uitk-react-text';

interface Props {
  formatContent(label: string): string;
}

const spacingPaddingProps: UitkSpacingSpacesBreaks = { medium: { block: 'sixteen' }, small: { block: 'sixteen' } };

export const RelationsSection: React.FC<Props> = ({ formatContent }) => {
  return (
    <UitkLayoutFlexItem className="relations-container home-spacing">
      <section id="relations-section">
        <UitkSpacing padding={spacingPaddingProps}>
          <UitkLayoutGrid columns={{ medium: ['1fr'] }} space="twelve" className="marketing-page-width">
            <UitkSpacing margin={{ blockstart: 'three' }}>
              <UitkLayoutGridItem>
                <UitkText align="center" size={700}>
                  {formatContent('brandsSection.Relation')}
                </UitkText>
              </UitkLayoutGridItem>
            </UitkSpacing>

            <UitkLayoutGrid
              space={{
                column: 'four',
                row: 'six',
              }}
              columns={{ medium: 4, small: 1 }}
              className="cards"
            >
              <UitkLayoutGridItem>
                <UitkSpacing padding={'twelve'}>
                  <div>
                    <UitkText align="center" size={600}>
                      {formatContent('brandsSection.Relation.numberOfTravelerReviews')}
                    </UitkText>
                    <UitkText align="center" size={300} spacing="two">
                      {formatContent('brandsSection.Relation.travelerReviews')}
                    </UitkText>
                  </div>
                </UitkSpacing>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem>
                <UitkSpacing padding={'twelve'}>
                  <div>
                    <UitkText align="center" size={600}>
                      {formatContent('brandsSection.Relation.numberOfPropertyImages')}
                    </UitkText>
                    <UitkText align="center" size={300} spacing="two">
                      {formatContent('brandsSection.Relation.propertyImages')}
                    </UitkText>
                  </div>
                </UitkSpacing>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem>
                <UitkSpacing padding={'twelve'}>
                  <div>
                    <UitkText align="center" size={600}>
                      {formatContent('brandsSection.Relation.numberOfintelligentGeographyMappings')}
                    </UitkText>
                    <UitkText align="center" size={300} spacing="two">
                      {formatContent('brandsSection.Relation.intelligentGeographyMappings')}
                    </UitkText>
                  </div>
                </UitkSpacing>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem>
                <UitkSpacing padding={'twelve'}>
                  <div>
                    <UitkText align="center" size={600}>
                      {formatContent('brandsSection.Relation.numberOfLanguagesOffered')}
                    </UitkText>
                    <UitkText align="center" size={300} spacing="two">
                      {formatContent('brandsSection.Relation.languagesOffered')}
                    </UitkText>
                  </div>
                </UitkSpacing>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem>
                <UitkSpacing padding={'twelve'}>
                  <div>
                    <UitkText align="center" size={600}>
                      {formatContent('brandsSection.Relation.numberOfAIPredictions')}
                    </UitkText>
                    <UitkText align="center" size={300} spacing="two">
                      {formatContent('brandsSection.Relation.AIPredictions')}
                    </UitkText>
                  </div>
                </UitkSpacing>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem>
                <UitkSpacing padding={'twelve'}>
                  <div>
                    <UitkText align="center" size={600}>
                      {formatContent('brandsSection.Relation.numberOfVirtualConversations')}
                    </UitkText>
                    <UitkText align="center" size={300} spacing="two">
                      {formatContent('brandsSection.Relation.virtualConversations')}
                    </UitkText>
                  </div>
                </UitkSpacing>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem>
                <UitkSpacing padding={'twelve'}>
                  <div>
                    <UitkText align="center" size={600}>
                      {formatContent('brandsSection.Relation.numberOfDataPointsTracked')}
                    </UitkText>
                    <UitkText align="center" size={300} spacing="two">
                      {formatContent('brandsSection.Relation.dataPointsTracked')}
                    </UitkText>
                  </div>
                </UitkSpacing>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem>
                <UitkSpacing padding={'twelve'}>
                  <div>
                    <UitkText align="center" size={600}>
                      {formatContent('brandsSection.Relation.numberOfUniqueActivities')}
                    </UitkText>
                    <UitkText align="center" size={300} spacing="two">
                      {formatContent('brandsSection.Relation.uniqueActivities')}
                    </UitkText>
                  </div>
                </UitkSpacing>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </UitkLayoutGrid>
        </UitkSpacing>
      </section>
    </UitkLayoutFlexItem>
  );
};

RelationsSection.displayName = 'RelationsSection';
